import Typography from "@mui/material/Typography";

const ncoaLinkTerms: JSX.Element =
    <>
        <Typography variant={"h5"}>
            NCOA<sup>Link</sup><br/>
        </Typography>
        <Typography>
            The collection of information on this Processing Acknowledgement
            Form (PAF) is required by the Privacy Act of 1974. The United States
            Postal Service®(USPS®) requires that each NCOA<sup>Link</sup> Licensee
            have a completed NCOA<sup>Link</sup> PAF for each of their
            NCOA<sup>Link</sup> customers prior to providing the NCOA<sup>Link</sup>
            service. The Licensee is also required by the USPS® to retain a copy of
            the completed form for each of its customers and to obtain an updated
            PAF from each of its customers at minimum once per year.
        </Typography>
        <br/>
        <Typography>
            I do hereby acknowledge that I have received and reviewed the
            NCOA<sup>Link</sup> Information Package supplied to me by Data Axle,
            an NCOA<sup>Link</sup> Service Provider. I also understand that the sole
            purpose of the NCOA<sup>Link</sup> service is to provide a mailing
            list correction service for lists that will be used for preparation
            of mailings. Furthermore, I understand that NCOA<sup>Link</sup>
            may not be used to create or maintain new movers lists.
        </Typography>
        <br/>
    </>


const ncoaFulfillmentWaiverTerms: JSX.Element =
    <>
        <Typography>
            The USPS® requires that all of its
            NCOA<sup>Link</sup> licensees process and return all customer address list files
            within seven (7) business days of receipt unless a longer period is specified by
            the customer in writing. Data Axle considers the completed NCOA<sup>Link</sup> PAF
            associated with this document as acknowledgement in writing by the signatory that
            in some circumstances, services requested from Data Axle may take longer than
            seven (7) business days to complete as stipulated by the USPS®.
        </Typography>
        <br/>
    </>


const dsf2Terms: JSX.Element =
    <>
        <Typography variant={"h5"}>
            DSF<sup>2</sup>
        </Typography>
        <Typography>
            The data contained within the DSF<sup>2</sup> Product is governed by
            39 USC 412 specifically prohibiting the disclosure of mailing lists.
            The USPS® requires that each DSF<sup>2</sup> licensee have a written
            agreement for each of their DSF<sup>2</sup> customers prior to providing
            the DSF<sup>2</sup> service to prevent unlawful disclosure of USPS®
            address data. This Processing Acknowledgement Form (PAF) constitutes
            that agreement.
        </Typography>
        <br/>
        <Typography>
            I do hereby acknowledge that I understand the purpose of the DSF<sup>2</sup> service as
            provided by Data Axle, a DSF<sup>2</sup> Licensee, is to process address lists for address
            hygiene, address attribute assignment, and address sequencing services to be
            used solely for the preparation of mailings to be submitted to the USPS® for
            acceptance and delivery.
        </Typography>
        <br/>
    </>


const signatureDisclaimer: JSX.Element =
    <>
        <Typography>
            Any signature provided here shall be considered valid for all purposes
            and have the same effect as an ink-signed hardcopy document.
        </Typography>
    </>


export const SignatureTerms = {
    ncoaLinkTerms,
    ncoaFulfillmentWaiverTerms,
    dsf2Terms,
    signatureDisclaimer,
};